const setPageTitle = (title) => {
  document.title = `${title} | Tesla`;
};

export default setPageTitle;
